import { z } from 'zod/v4';

export const BulkUnarchiveActionsRequestSchema = z.object({
  actionIds: z
    .array(z.string().min(1, 'Action ID is required'))
    .min(1, 'At least one action ID is required')
    .max(100, 'Maximum 100 action IDs allowed per request'),
});

export type BulkUnarchiveActionsRequest = z.infer<
  typeof BulkUnarchiveActionsRequestSchema
>;
